import React, { FC, useState } from 'react';
import { Button } from '@mui/material';
import { Select, Typography } from 'antd';
import Box from '@mui/material/Box';

const { Text } = Typography;

const curriculumOptions = [
  { value: 'Cambridge', label: 'Cambridge' },
  { value: 'IB', label: 'IB' },
  { value: 'CBSE', label: 'CBSE' },
  { value: 'ICSE', label: 'ICSE' },
];

const languageOptions = [
  { value: '', label: 'Select Language' },
  { value: 'english', label: 'English' },
  { value: 'sinhala', label: 'Sinhala' },
  { value: 'tamil', label: 'Tamil' },
];

/** The green curriculum / language bar shown under the main header. */
const GreenHeader: FC = () => {
  const [curriculum, setCurriculum] = useState('Cambridge');
  const [language, setLanguage] = useState('');

  return (
    <Box style={{ minHeight: '64px', backgroundColor: '#417C4C', padding: '0 6%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
      <Text strong style={{ display: 'block', fontSize: 16,  color: '#fff' }}>
        Curriculum
      </Text>
      <Select
        className={'green-header'}
        value={curriculum}
        onChange={setCurriculum}
        options={curriculumOptions}
        size="large"
        style={{
          width: '240px',
          color: '#fff !important',
        }}
      />
      <Text strong style={{ display: 'block', fontSize: 16,  color: '#fff' }}>
        Language
      </Text>
      <Select
        className={'green-header'}
        value={language}
        onChange={setLanguage}
        options={languageOptions}
        size="large"
        style={{ width: '240px',  color: '#fff !important' }}
        placeholder="Select Language"
      />
      <Button
        style={{
          width: '120px',
          background: 'white',
          color: '#000000',
          height: 40,
          borderRadius: '15px',
        }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default GreenHeader;
